import type { HTMLAttributes, ReactNode } from 'react';

import styles from './Badge.module.css';

type BadgeSize = 'small' | 'medium' | 'big';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  size?: BadgeSize;
  children: ReactNode;
}

// PARA-120 — общий примитив бейджа (по образцу primitives/Badge.jsx). Цвет — по семантике
// размера задачи (mint/sky/lavender), всегда nowrap, чтобы "N/M" не переносилось (AC-3, AC-5).
export function Badge({ size = 'small', className, children, ...rest }: BadgeProps): JSX.Element {
  const classes = [styles.badge, styles[size], className].filter(Boolean).join(' ');

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}
